import type { MouseEventHandler } from "react"
import { IconSizeProps, IconXX } from "./Icon"

export type IconButtonProps = IconSizeProps & {
  id?: string
  ariaLabel: string // 버튼에 별도 명시
  iconSize: number
  onClick: MouseEventHandler<HTMLButtonElement> // 클릭 이벤트 핸들러
  "aria-expanded"?: boolean
  "aria-controls"?: string
}

export const IconButton = ({
  id,
  src,
  color,
  iconSize = 12 | 16 | 18 | 20 | 24 | 28,
  ariaLabel,
  onClick,
  priority,
  "aria-expanded": ariaExpanded,
  "aria-controls": ariaControls,
}: IconButtonProps) => {
  return (
    <button
      id={id}
      type="button"
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      onClick={onClick}
      className={`-m-2 inline-flex items-center justify-center p-2`}
      // 디버깅용 코드 (터치라인 보임)
      // className={`-m-2 inline-flex items-center justify-center p-2 outline-1 outline-red-600`}
    >
      <IconXX
        size={iconSize}
        src={src}
        color={color}
        ariaLabel={ariaLabel}
        priority={priority}
      />
    </button>
  )
}
